import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { faChevronRight, faLock, faRightFromBracket, faUser, faWallet, faTrash, faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ListSubheader } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function AnchorTemporaryDrawer() {
  const navigate = useNavigate();
  const [state, setState] = React.useState({
    right: false,
  });

const handleNavigation = (path) => {
  navigate(path);
  setState({ right: false });
};

const handleLogout =()=>{
  window.localStorage.removeItem("user");
  window.localStorage.removeItem("access_token");
  window.location.replace("/"); 
};


  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ right: open });
  };

  const list = () => (
    <Box
      sx={{ width: 250, backgroundColor: '#f3f4f6' }} 
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List
        subheader={
          <ListSubheader component="h1" id="nested-list-subheader">
            <span className="text-md">My Account</span>
          </ListSubheader>
        }
      >
        <Divider className="pb-2" />
        <ListItem key="MyWallet" disablePadding className="bg-white">
          <ListItemButton onClick={() => handleNavigation('/wallet')}>
            <ListItemIcon>
              <FontAwesomeIcon
                icon={faWallet}
                className="text-[#BE1F18] bg-gray-200 p-3 rounded-full"
              />
            </ListItemIcon>
            <ListItemText primary="My Wallet" />
            <FontAwesomeIcon icon={faChevronRight} />
          </ListItemButton>
        </ListItem>
        <Divider className="pb-2" />

        <ListItem key="Profile" disablePadding className="bg-white">
          <ListItemButton onClick={() => handleNavigation('/myProfile')}>
            <ListItemIcon>
              <FontAwesomeIcon
                icon={faUser}
                className="text-[#BE1F18] bg-gray-200 p-3 rounded-full"
              />
            </ListItemIcon>
            <ListItemText primary="Profile" />
            <FontAwesomeIcon icon={faChevronRight} />
          </ListItemButton>
        </ListItem>
        <Divider className="pb-2" />

        <ListItem key="UpdatePassword" disablePadding className="bg-white">
          <ListItemButton onClick={() => handleNavigation('/updatePassword')}>
            <ListItemIcon>
              <FontAwesomeIcon
                icon={faLock}
                className="text-[#BE1F18] bg-gray-200 p-3 rounded-full"
              />
            </ListItemIcon>
            <ListItemText primary="Update Password" />
            <FontAwesomeIcon icon={faChevronRight} />
          </ListItemButton>
        </ListItem>
        <Divider className="pb-2" />
        
        <ListItem key="DeleteAccount" disablePadding className="bg-white">
          <ListItemButton onClick={() => handleNavigation('/deleteAccount')}>
            <ListItemIcon>
              <FontAwesomeIcon
                icon={faTrash}
                className="text-[#BE1F18] bg-gray-200 p-3 rounded-full"
              />
            </ListItemIcon>
            <ListItemText primary="Delete Account" />
            <FontAwesomeIcon icon={faChevronRight} />
          </ListItemButton>
        </ListItem>
        <Divider className="pb-2" />

        <ListItem key="Logout" disablePadding className="bg-white">
          <ListItemButton onClick={() => handleLogout()}>
            <ListItemIcon>
              <FontAwesomeIcon
                icon={faRightFromBracket}
                className="text-[#BE1F18] bg-gray-200 p-3 rounded-full"
              />
            </ListItemIcon>
            <ListItemText primary="Logout" />
            <FontAwesomeIcon icon={faChevronRight} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <div>
      <Button 
        onClick={toggleDrawer(true)} 
        sx={{
          color: 'white', 
          fontSize: '2rem', 
          outline: 'none', 
          '&:focus': { outline: 'none' }
        }}
      >
        <FontAwesomeIcon icon={faBars} />
      </Button>

      <Drawer
        anchor="right"
        open={state.right}
        onClose={toggleDrawer(false)}
        sx={{ '& .MuiDrawer-paper': { backgroundColor: '#f3f4f6' } }}
      >
        {list()}
      </Drawer>
    </div>
  );
}
